module.exports = __webpack_public_path__ + "static/media/LR.d636c8ad.svg";